export default __webpack_public_path__ + "static/media/monitorSilverIcon.eda26d75.svg";